module.exports = __webpack_public_path__ + "img/viruses.1d61f280.svg";